import { Injectable } from '@angular/core';
import { routes } from 'app/app.routing.module';
import { SideNavComponent } from 'app/shared/components/side-nav/side-nav.component';
import { UserProfileService } from 'app/shared/user-profile/user-profile.service';

@Injectable({
  providedIn: 'root'
})

export class DefaultModuleService  {

  constructor(
    private userProfileService: UserProfileService,
  ) {
    /* Update the routes object to set the redirectTo field to the first available module on the user's module list */
    const defaultRoutes = routes.filter(r => r.path === '' || r.path === '**');
    defaultRoutes.map(r => r.redirectTo = this.getDefaultModule());
  }

  private basicModules = SideNavComponent.sidebarItemsRAW
  .filter(item => item.module !== 'module_operate_windlog')
  .map(item => ({
    keycloakName: item.module,
    moduleName:    item.route
  }));

  public getDefaultModule(): string {
    let defaultModule = this.basicModules[0].moduleName;
    const customDefaultModule = localStorage.getItem('wind-custom-default-module');
  
    if (customDefaultModule) {
      const module = this.basicModules.find(m => m.moduleName === customDefaultModule);
      if (module) {
        if (this.userProfileService.canAccessToModule(module.keycloakName)) {
          defaultModule = module.moduleName;
        }
      }
    } else {
      for (const module of this.basicModules) {
        if (this.userProfileService.canAccessToModule(module.keycloakName)) {
          defaultModule = module.moduleName;
          break;
        }
      }
    }
  
    return defaultModule;
  }
}

